import React from 'react';
import { Bar } from 'react-chartjs-2';
import useTheme from '../../../../customHooks/useTheme';
import { getCSSVariable } from '../../../../stylesheets/cssVariablesUtils';
import useTranslate from '../../../../customHooks/useTranslate';

const BookingChart = ({
    chartData,
    bookingsData,
    containerClassName = 'booking-chart__container',
}) => {
    const translate = useTranslate();
    const { getThemeColor } = useTheme();

    const borderColor = getThemeColor('grey400');
    return (
        <div className={containerClassName}>
            <Bar
                data={chartData}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 2,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        callbacks: {
                            title: ([tooltipItem]) => {
                                return `${translate(
                                    bookingsData[tooltipItem.index].month
                                )} - ${bookingsData[tooltipItem.index].year}`;
                            },
                        },
                    },
                    dataset: {
                        barThickness: 18,
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    drawOnChartArea: false,
                                    drawTicks: false,
                                    color: borderColor,
                                },
                                ticks: {
                                    color: borderColor,
                                    beginAtZero: true,
                                    fontSize: 10,
                                    fontFamily: getCSSVariable('mainFont'),
                                    padding: 5,
                                    fontColor: borderColor,
                                },
                            },
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    drawOnChartArea: false,
                                    lineWidth: 0.5,
                                    drawTicks: false,
                                    color: borderColor,
                                },
                                ticks: {
                                    color: borderColor,
                                    beginAtZero: true,
                                    fontSize: 10,
                                    fontFamily: getCSSVariable('mainFont'),
                                    fontColor: borderColor,
                                    padding: 5,
                                    stepSize: 1,
                                    callback: value => {
                                        if (Number.isInteger(value)) {
                                            return value;
                                        }
                                        return null;
                                    },
                                },
                                // stacked: true,
                            },
                        ],
                    },
                }}
            />
        </div>
    );
};

export default BookingChart;
